export function determineCandleTriggerCandleDuration(setupDetails) {
  return setupDetails.candleDuration;
}
